import {FC} from 'react'
import {Link, useNavigate} from 'react-router-dom'

const ErrorAuth: FC = () => {
  const navigate = useNavigate()

  const handleClickBack = () => {
    navigate(-1)
  }

  return (
    <>
      <div className='d-flex flex-column flex-root background_card text-center'>
        <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Unauthorised</h1>
        <div className='fw-bold fs-3 text-gray-400 mb-15'>
          Unauthorised! <br /> You have no access to view this page.
        </div>
        <div className='text-center'>
          <button
            onClick={handleClickBack}
            type='button'
            className='btn btn-secondary'
            data-kt-stepper-action='previous'
            tabIndex={0}
          >
            Back
          </button>
          <Link to='/logout' className='btn btn-primary ms-5 fw-bolder'>
            Logout
          </Link>
        </div>
      </div>
    </>
  )
}

export {ErrorAuth}
